import WaGroupService from '../../services/WaGroupService'

// Grupos de WhatsApp do tenant (Cloud API Groups). A lista alimenta a tela de
// conversas (nome/ícone dos grupos — a chave da conversa é o group_id) e o
// modal de gerenciamento (criar/editar/excluir/link de convite).
const state = () => ({
    waGroups: [],
    loadingWaGroups: false,
    savingWaGroup: false,
})

const mutations = {
    SET_WA_GROUPS: (state, payload) => {
        state.waGroups = payload || []
    },
    SET_LOADING_WA_GROUPS: (state, payload) => {
        state.loadingWaGroups = payload
    },
    SET_SAVING_WA_GROUP: (state, payload) => {
        state.savingWaGroup = payload
    },
}

const actions = {
    async fetchWaGroups({ commit }) {
        try {
            commit('SET_LOADING_WA_GROUPS', true)
            const response = await WaGroupService.list()
            commit('SET_WA_GROUPS', response.data)
        } catch (error) {
            console.error('Falha ao carregar os grupos de WhatsApp:', error)
        } finally {
            commit('SET_LOADING_WA_GROUPS', false)
        }
    },

    async syncWaGroups({ commit, dispatch }) {
        try {
            commit('SET_SAVING_WA_GROUP', true)
            await WaGroupService.sync()
            await dispatch('fetchWaGroups')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao sincronizar os grupos.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_GROUP', false)
        }
    },

    /** Cria o grupo na Meta. Retorna o registro criado (ou null se falhar). */
    async createWaGroup({ commit, dispatch }, { subject, description }) {
        try {
            commit('SET_SAVING_WA_GROUP', true)
            const response = await WaGroupService.create({ subject, description })
            await dispatch('fetchWaGroups')
            return response.data?.item || null
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao criar o grupo.'
            })
            return null
        } finally {
            commit('SET_SAVING_WA_GROUP', false)
        }
    },

    async updateWaGroup({ commit, dispatch }, { id, subject, description }) {
        try {
            commit('SET_SAVING_WA_GROUP', true)
            await WaGroupService.update(id, { subject, description })
            await dispatch('fetchWaGroups')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao atualizar o grupo.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_GROUP', false)
        }
    },

    async deleteWaGroup({ commit, dispatch }, id) {
        try {
            commit('SET_SAVING_WA_GROUP', true)
            await WaGroupService.remove(id)
            await dispatch('fetchWaGroups')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao excluir o grupo.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_GROUP', false)
        }
    },

    async resetWaGroupInviteLink({ commit, dispatch }, id) {
        try {
            commit('SET_SAVING_WA_GROUP', true)
            const response = await WaGroupService.resetInviteLink(id)
            await dispatch('fetchWaGroups')
            return response.data?.invite_link || null
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao resetar o link de convite.'
            })
            return null
        } finally {
            commit('SET_SAVING_WA_GROUP', false)
        }
    },

    async removeWaGroupParticipants({ commit, dispatch }, { id, users }) {
        try {
            commit('SET_SAVING_WA_GROUP', true)
            await WaGroupService.removeParticipants(id, users)
            await dispatch('fetchWaGroups')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao remover o participante.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_GROUP', false)
        }
    },
}

const getters = {
    getWaGroups: state => state.waGroups,
    getLoadingWaGroups: state => state.loadingWaGroups,
    getSavingWaGroup: state => state.savingWaGroup,
    /** Grupo pelo group_id (chave da conversa) — usado pela tela de conversas */
    getWaGroupByKey: state => (key) => state.waGroups.find(g => g.group_id === key) || null,
}

export default {
    state,
    getters,
    mutations,
    actions
};
